import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout" 
import Header from "../components/header"
import Footer from "../components/sitefooter"

//import { Map, TileLayer, Marker, Popup } from 'react-leaflet'
// import Img from "gatsby-image";
import "../pages/mystyles.scss"




export default ({ data }) => {
    const post = data.airtable
      
        
  return (
    <>
    <Header></Header>
    <Layout>
      <container>

      <section class="section">
  <div class="container">
    <div class="columns is-vcentered">
      <div class="column is-6">
        <h2 class="title is-family-secondary">{post.data.Title}</h2>
        <p class="subtitle"><strong><Link to={post.data.NewArtistSlug}>{post.data.Artists_Name}</Link></strong></p>
        <p class="subtitle"><strong>First placed in Singapore:</strong> {post.data.Year_Artwork_Placed_in_Singapore}</p>
        <p class="subtitle">{post.data.Current_Location}</p>
        <p class="subtitle"><em>{checkBlank(post.data.Location_Notes)}</em></p>
        <p class="subtitle"><strong>Patron:</strong> {post.data.Patron}</p>
        <p dangerouslySetInnerHTML={{__html: post.data.Entry}} class="subtitle"></p>
        {post.data.TextofLabel !== null &&
        
        <div>
          <h5>Text of the Label:</h5>
        <p dangerouslySetInnerHTML={{__html: post.data.TextofLabel}}></p></div>
}
<p class="is-italic is-size-7">Last updated: {post.data.Last_Modified}</p>
      </div>
      <div class="column is-6">
      {post.data.airImage !== null &&
        <image>
        <img src={post.data.airImage.localFiles[0].childImageSharp.fixed.src} alt={post.data.Title} />
        </image>
        }
        
      </div>
    </div>
  </div>
</section>
<section class="section">
<div class="container py-4">
  <div>
{post.data.airImage !== null && 
  <div class="columns is-multiline"> 
{post.data.airImage.localFiles.map ((photo, index) =>
<div class="column is-one-third" >
{index === 0 

? null
: <image  key={index}> <img src={photo.childImageSharp.fixed.src} alt="additional photograph of the sculpture on this page"></img></image>
 }
</div>
)
}


</div>
}
  
</div>
 </div>
</section>

       




      
    <Footer></Footer>
      </container>
      </Layout>
      </>
    )
  
}

export const query = graphql`

query($artworkSlug: String!){
  airtable (data: {slashArtworkSlug: {eq: $artworkSlug }}) {
  
    data {
      slashArtworkSlug
      Title
      ArtistSlug
      Artists_Name
      Current_Location
      Entry 
      Latitude
      Location_Notes
      Longitude
      Patron
      TextofLabel
      Year_Artwork_Placed_in_Singapore(formatString: "YYYY")
      NewArtistSlug
      Last_Modified(formatString: "MMM-D-YYYY")
      airImage {
        localFiles {
          childImageSharp {
            fixed(width: 600) {
            src
            }
            resize(width: 500, grayscale: true) {
               src
              }
          }
        }
      }
    }
      
    
  }
}
`
let checkBlank = value => (value ? value : `-`);